<template lang="pug">
select.form-control.c-select(
    name="outlet",
    :class="className",
    @change="setOutlet"
)
    option(
        :value="null",
        :selected="useVuex ? (activeOutlet == 0 || activeOutlet == null) : value == null"
    ) {{ placeholder }}
    
    option(
        v-for="outlet in outlets",
        :value="outlet.id",
        :selected="useVuex ? activeOutlet == outlet.id : value == outlet.id"
    ) {{ outlet.name }}
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    props: {
        className: {
            type: String,
            default: '',
        },

        value: {
            type: Number,
            default: null,
        },

        useVuex: {
            type: Boolean,
            default: true,
        },

        placeholder: {
            type: String,
            default: 'Select Outlet',
        },

        userOutletOnly: {
            type: Boolean,
            default: true,
        },

        excludeId: {
            type: Number,
            default: null,
        },
    },

    computed: {
        api() {
            return Laroute.route('data_api.all-outlet');
        },

        ...mapGetters(['activeOutlet']),
        ...mapGetters('outlet', ['outletList']),

        outlets() {
            const outlets = [];

            this.outletList.forEach(outlet => {
                // if (this.userOutletOnly && !this.isSuperAdmin()) {
                //     if (this.userOutlets.includes(outlet.id)) {
                //         outlets.push(outlet);
                //     }
                // } else {
                //     outlets.push(outlet);
                // }
                let check_outlets = this.userOutlets.length == 0;

                if (this.userOutlets.includes(outlet.id)) {
                    outlets.push(outlet);
                } else if (check_outlets && this.isSuperAdmin()) {
                    outlets.push(outlet);
                }
            });

            if (!_.isNull(this.excludeId)) {
                return outlets.filter(o => o.id != this.excludeId);
            }

            return outlets;
        },
    },

    mounted() {
        if (!this.outletList.length) {
            this.getOutletList();
        }
    },

    methods: {
        ...mapMutations(['setActiveOutlet']),

        ...mapActions('outlet', ['getOutletList']),

        setOutlet(e) {
            const value =
                e.target.value != null && e.target.value.trim() != ''
                    ? parseInt(e.target.value)
                    : null;

            if (this.useVuex) {
                this.setActiveOutlet(value);
            }

            this.$emit('input', value);
            this.$emit('onChange', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/outlet-selector.vue